/**
 * attaches attribute values of DataTh/DataTd to its className
 *
 * @param multiRow {boolean|string}
 * @param multiCol {boolean|string}
 * @param className {string}
 * @returns {string}
 */

export const getClassList = ({ multiRow, multiCol, className }) => {
  const classList = []
  if (multiRow) {
    classList.push(
      `multi-row${ typeof multiRow === 'string' ? `-${ multiRow }` : '' }`
    )
  }
  if (multiCol) {
    classList.push(
      `multi-col${ typeof multiCol === 'string' ? `-${ multiCol }` : '' }`
    )
  }
  if (className) {
    classList.push(className)
  }
  return classList.join(' ')
}
